import {useState} from "preact/hooks";

export const usePaginator = props => {
    // Destructured props
    const {
        data,
        handlePagination,
    } = props;

    // State to store the current selected page
    const [currentPage, setCurrentPage] = useState(1);

    // Method to handle the page change
    const handleChange = (currentItem) => {
        // Sets the new page index into the "currentPage" state
        setCurrentPage(currentItem);

        // Paginates to the desired page
        handlePagination({
            page: currentItem
        })
    }

    // Method to handle the "Anterior" and "Próximo" buttons
    const handleManualChange = action => {
        switch (action) {
            case "prev":
                setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));

                // Paginates to the desired page
                handlePagination({
                    page: currentPage - 1
                })

                break;

            case "next":
                setCurrentPage((prevPage) => Math.min(prevPage + 1, Math.ceil(data.totalCount / data.pageSize)));

                // Paginates to the desired page
                handlePagination({
                    page: currentPage + 1
                })

                break;

            default:
                return;
        }
    }

    return {
        currentPage,
        handleChange,
        handleManualChange
    }
}
